module.exports = __webpack_public_path__ + "static/img/Wheel-On.fe4dfc58.png";